import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/competence/competencetaskattachment/";

export default class CompetenceTaskAttachmentApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getCompetenceTaskAttachments(params) {
    return await request.post(`${rootRoute}getCompetenceTaskAttachments`, {
      filter: params,
      parameters: {},
    });
  }
  async getCompetenceTaskAttachment(id) {
    return await request.post(`${rootRoute}getCompetenceTaskAttachments`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createCompetenceTaskAttachment(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createCompetenceTaskAttachment`, { data });
  }
  async deleteCompetenceTaskAttachment(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteCompetenceTaskAttachment`, { data });
  }
  async editCompetenceTaskAttachment(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateCompetenceTaskAttachment`, { data });
  }
  async setStatusCompetenceTaskAttachment(models) {
    const data = models;
    return await request.post(`${rootRoute}setStatusCompetenceTaskAttachment`, { data });
  }
}
